// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"2688":"9ffa5d91","8799":"69b8c547"}[chunkId] + ".css";
};